import { render } from "./headertwo.vue?vue&type=template&id=55d75c7d"
import script from "./headertwo.vue?vue&type=script&lang=js"
export * from "./headertwo.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__